<template>
  <div>
    <b-button
      v-if="!branchForm"
      variant="primary"
      @click="addBranch()"
      class="mb-1"
    >
      Add Branch
    </b-button>

    <div v-if="branchForm">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Branch Name"
              invalid-feedback="Branch Name is required"
              ref="b_name"
            >
              <b-form-input
                v-model.trim="branchObj.branch"
                placeholder="Enter branch name"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Account Number"
              invalid-feedback="Account Number is required"
              ref="b_no"
            >
              <b-form-input
                v-model.trim="branchObj.accountNumber"
                placeholder="Enter Account number"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              label="Campuses"
              invalid-feedback="Campuses is required"
              ref="b_camp"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="selectedCamp"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="[{ branch: 'All Campuses', id: 0 }, ...campuses]"
                :clearable="false"
                :reduce="(val) => val.id"
                label="branch"
                placeholder="Select campus"
                @input="setCampus()"
              ></v-select>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="text-right py-1 border-top">
          <b-button
            type="submit"
            variant="success"
            class="mr-1"
            :disabled="savingBranch"
            @click="saveBranch(false)"
          >
            <b-spinner v-if="savingBranch && !applying" small type="grow" />
            <span v-else>{{$t('Save')}}</span>
          </b-button>
          <b-button
            type="submit"
            variant="info"
            class="mr-1"
            :disabled="savingBranch"
            @click="saveBranch(true)"
            style="min-width: 130px"
          >
            <b-spinner v-if="savingBranch && applying" small type="grow" />
            <span v-else>Save & Apply</span>
          </b-button>
          <b-button
            variant="outline-secondary"
            :disabled="savingBranch"
            @click="branchForm = false"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </div>

    <div v-else>
      <b-table
        sticky-header="400px"
        :items="branchItems"
        :fields="branchFields"
        responsive
        hover
        :busy="branchLoading"
        show-empty
        small
      >
        <template #table-busy>
          <div class="d-flex justify-content-center my-3">
            <b-spinner
              style="width: 2rem; height: 2rem"
              type="grow"
              variant="primary"
              label="Spinning"
            ></b-spinner>
          </div>
        </template>

        <template #cell(campuses)="data">
          <b-badge
            variant="light-primary"
            v-for="cc in data.item.linkedCampuses.split(',')"
            :key="cc"
            class="m-25"
          >
            <span>{{ getCampus(cc) }}</span>
          </b-badge>
        </template>
        <template #cell(actions)="data">
          <b-button
            variant="primary"
            class="btn-icon"
            @click="editBranch(data.item)"
          >
            <feather-icon icon="EditIcon" />
          </b-button>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import {
  BRow,
  BCol,
  BTable,
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BSpinner,
  BBadge,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { mapActions } from "vuex";

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BSpinner,
    BBadge,
    vSelect,
  },
  data() {
    return {
      branchItems: [],
      branchFields: [
        { label: "name", key: "branch" },
        { label: "campuses", key: "campuses" },
        { label: "actions", key: "actions" },
      ],
      branchLoading: false,
      branchObj: {
        id: 0,
        accountID: 0,
        campusID: 0,
        branch: "",
        accountNumber: "",
        linkedCampuses: "",
      },
      branchForm: false,
      savingBranch: false,
      applying: false,
      selectedCamp: [],
    };
  },
  props: {
    currentAccount: {
      type: Object,
      default: () => ({}),
      required: false,
    },
    campuses: {
      type: Array,
      default: () => [],
    },
    getCampus: {
      type: Function,
      required: true,
    },
  },
  created() {
    this.showAccBranch();
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    async showAccBranch() {
      this.selectedCamp = [];
      this.branchForm = false;

      this.branchLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "CollectionAccountBranch/LoadData?db=" +
          this.$store.state.userData.db +
          "&accID=" +
          this.currentAccount.id +
          "&campID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.branchItems = await this.get(obj);
      // console.log(this.branchItems);
      this.branchLoading = false;
    },
    addBranch() {
      this.branchObj = {
        id: 0,
        accountID: this.currentAccount.id,
        campusID: this.currentAccount.campusID,
        branch: "",
        accountNumber: "",
        linkedCampuses: "",
      };
      this.selectedCamp = [];
      this.branchForm = true;
    },
    editBranch(item) {
      this.branchObj = { ...item };
      this.selectedCamp = item.linkedCampuses
        .split(",")
        .filter((el) => el)
        .map(Number);
      this.branchForm = true;
    },
    setCampus() {
      if (this.selectedCamp.at(-1) == 0) {
        this.selectedCamp = [0];
      } else {
        this.selectedCamp = this.selectedCamp.filter((el) => el != 0);
      }
    },
    CheckBName() {
      var elem = this.$refs["b_name"];
      if (this.branchObj.branch == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBNo() {
      var elem = this.$refs["b_no"];
      if (this.branchObj.accountNumber == "") {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    CheckBCamp() {
      var elem = this.$refs["b_camp"];
      if (this.selectedCamp.length == 0) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    async saveBranch(val) {
      this.CheckBName();
      this.CheckBNo();
      this.CheckBCamp();
      if (
        this.CheckBName() == false ||
        this.CheckBNo() == false ||
        this.CheckBCamp() == false
      ) {
        return this.$bvToast.toast("Please enter the fields correctly.", {
          title: this.$t("Error!"),
          variant: "danger",
          toaster: "b-toaster-top-center",
        });
      } else {
        this.savingBranch = true;
        this.applying = val;

        if (this.selectedCamp[0] == 0) {
          this.branchObj.linkedCampuses = this.campuses
            .map((el) => el.id)
            .join(",");
        } else {
          this.branchObj.linkedCampuses = this.selectedCamp.join(",");
        }
        // console.log(this.branchObj);

        let status = false;
        if (val) {
          status = await this.post({
            url:
              this.$store.state.domain +
              "CollectionAccountBranch/Apply?db=" +
              this.$store.state.userData.db,
            body: this.branchObj,
            message: "Branch saved & applied successfully.",
            context: this,
            token: this.$store.state.userData.token,
          });
        } else {
          if (this.branchObj.id == 0) {
            status = await this.post({
              url:
                this.$store.state.domain +
                "CollectionAccountBranch?db=" +
                this.$store.state.userData.db,
              body: this.branchObj,
              message: "Branch added successfully.",
              context: this,
              token: this.$store.state.userData.token,
            });
          } else {
            status = await this.put({
              url:
                this.$store.state.domain +
                "CollectionAccountBranch/" +
                this.branchObj.id +
                "?db=" +
                this.$store.state.userData.db,
              message: "Branch updated successfully.",
              context: this,
              body: this.branchObj,
              token: this.$store.state.userData.token,
            });
          }
        }
        this.savingBranch = false;
        this.applying = false;

        if (status) {
          this.branchForm = false;
          await this.showAccBranch();
        }
      }
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
